import React, { useEffect } from "react";
import { Modal, notification, Button, Form, Row, Col } from "antd";
import "../Modal/UserTableModal.css";
import { updatesUser } from "../../util/APIUtils";



const ModalComponent = ({ visible, onClose, selectedItem, onUpdate,}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedItem && selectedItem.fuelCampaignFormId) {
      form.setFieldsValue({
        fuelCampaignFormId: selectedItem.fuelCampaignFormId,
        nameSurname: selectedItem.nameSurname,
        email: selectedItem.email,
        phoneNumber: selectedItem.phoneNumber,
        tckn: selectedItem.tckn,
        taxAdministration: selectedItem.taxAdministration,
        city: selectedItem.city,
        county: selectedItem.county,
        pharmacy: selectedItem.pharmacy,
        address: selectedItem.address,
        fleetNumber: selectedItem.fleetNumber,
      });
    }else {
      form.resetFields();
    }

  }, [visible, selectedItem]);

  const handleUpdate = () => {
    form
        .validateFields()
        .then((values) => {
          const updatedItem = {
            fuelCampaignFormId: selectedItem.fuelCampaignFormId,
            nameSurname: values.nameSurname,
            email: values.email,
            phoneNumber: values.phoneNumber,
            tckn: values.tckn,
            taxAdministration: values.taxAdministration,
            city: values.city,
            county: values.county,
            pharmacy: values.pharmacy,
            address: values.address,
            fleetNumber: values.fleetNumber,
          };


          updatesUser(updatedItem, updatedItem.fuelCampaignFormId)
              .then(() => {
                notification.success({
                  message: "Başarılı",
                  description: "Kullanıcı başarıyla güncellendi.",
                });
                onClose();
                onUpdate(updatedItem);
              })
              .catch((error) => {
                console.error("Güncelleme hatası:", error);
                notification.error({
                  message: "Hata",
                  description: "Kullanıcı güncellenirken bir hata oluştu.",
                });
              });
        })
        .catch((error) => {
          console.error("Doğrulama hatası:", error);
        });
  };


  const handleOk = () => {
    handleUpdate();
  };
  const handleCancel = () => {
    onClose();
  };


  return (
      <div>
        {visible && (
            <div className="modal">
              <Modal
                  title={
                      selectedItem && (
                          <p>
                  <span style={{ fontWeight: "bold" }}>
                    {selectedItem.tckn}
                  </span>{" "}
                            -TCKN Numaralı Müşteri İçin İşlem Yapmaktasınız
                          </p>
                      )
                  }
                  visible={visible}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  width={600}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      İptal
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleOk}>
                      Kaydet
                    </Button>,
                  ]}
              >
                {selectedItem && (
                    <Form form={form} initialValues={selectedItem}>
                      <div
                          style={{ display: "flex", justifyContent: "space-between" }}
                      >
                        <div style={{ width: "48%" }}>
                          <Row gutter={16}>
                            <Col span={24}>
                              <Form.Item
                                  label="İsim-Soyisim"
                                  name="nameSurname"
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{ marginBottom: "1px" }}
                              >
                                <input
                                    className="task-input"
                                    type="text"
                                    onBlur={(e) => {
                                      if (!e.target.value.trim()) { // Eğer değer boşsa
                                        e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                      } else {
                                        e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                      }
                                    }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <Form.Item
                                  label="E-mail"
                                  name="email"
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{ marginBottom: "1px" }}
                                  rules={[
                                    {
                                      pattern: /^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/,
                                      message: 'Lütfen geçerli bir e-mail adresi girin.',
                                    },
                                  ]}
                              >
                                <input
                                    className="task-input"
                                    type="text"
                                    onBlur={(e) => {
                                      if (!e.target.value.trim()) { // Eğer değer boşsa
                                        e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                      } else {
                                        if (!/^[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(e.target.value)) {
                                          e.target.style.borderColor = "red"; // Eğer değer geçerli bir e-mail değilse
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }
                                    }}
                                />
                              </Form.Item>
                            </Col>



                            <Col span={24}>
                              <Form.Item
                                  label="Telefon Numarası"
                                  name="phoneNumber"
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{ marginBottom: "1px" }}
                              >
                                <input
                                    className="task-input"
                                    type="text"
                                    maxLength="10"
                                    pattern="\d{10}"
                                    title="Lütfen sadece 10 rakam girin."
                                    onInput={(e) => {
                                      if (e.target.value && isNaN(e.target.value.slice(-1))) {
                                        e.target.value = e.target.value.slice(0, -1);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      if (e.target.value.length < 10) {
                                        e.target.style.borderColor = "red"; // Hatalı girilmişse kırmızı yap
                                      } else {
                                        e.target.style.borderColor = ""; // Doğru girilmişse normal renge dön
                                      }
                                    }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <Form.Item
                                  label="TCKN"
                                  name="tckn"
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{ marginBottom: "1px" }}
                              >
                                <input
                                    className="task-input"
                                    type="text"
                                    maxLength="11"
                                    pattern="\d{11}"
                                    title="Lütfen sadece 11 rakam girin."
                                    onInput={(e) => {
                                      if (e.target.value && isNaN(e.target.value.slice(-1))) {
                                        e.target.value = e.target.value.slice(0, -1);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      if (e.target.value.length < 11) {
                                        e.target.style.borderColor = "red"; // Hatalı girilmişse kırmızı yap
                                      } else {
                                        e.target.style.borderColor = ""; // Doğru girilmişse normal renge dön
                                      }
                                    }}
                                />
                              </Form.Item>
                            </Col>


                            <Col span={24}>
                              <Form.Item
                                  label="Vergi Dairesi"
                                  name="taxAdministration"
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{ marginBottom: "1px" }}
                              >
                                <input
                                    className="task-input"
                                    type="text"
                                    onBlur={(e) => {
                                      if (!e.target.value.trim()) { // Eğer değer boşsa
                                        e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                      } else {
                                        e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                      }
                                    }}
                                />
                              </Form.Item>
                            </Col>

                          </Row>
                        </div>
                        <div style={{ width: "48%" }}>
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <Row gutter={16}>
                              <Col span={24}>
                                <Form.Item
                                    label="Şehir"
                                    name="city"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "1px" }}
                                >
                                  <input
                                      className="task-input"
                                      type="text"
                                      onBlur={(e) => {
                                        if (!e.target.value.trim()) { // Eğer değer boşsa
                                          e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={24}>
                                <Form.Item
                                    label="İlçe"
                                    name="county"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "1px" }}
                                >
                                  <input
                                      className="task-input"
                                      type="text"
                                      onBlur={(e) => {
                                        if (!e.target.value.trim()) { // Eğer değer boşsa
                                          e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={24}>
                                <Form.Item
                                    label="Eczane Adı"
                                    name="pharmacy"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "1px" }}
                                >
                                  <input
                                      className="task-input"
                                      type="text"
                                      onBlur={(e) => {
                                        if (!e.target.value.trim()) { // Eğer değer boşsa
                                          e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={24}>
                                <Form.Item
                                    label="Adres"
                                    name="address"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "1px" }}
                                >
                                  <input
                                      className="task-input"
                                      type="text"
                                      onBlur={(e) => {
                                        if (!e.target.value.trim()) { // Eğer değer boşsa
                                          e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={24}>
                                <Form.Item
                                    label="Filo Numarası"
                                    name="fleetNumber"
                                    labelCol={{ span: 24 }}
                                    wrapperCol={{ span: 24 }}
                                    style={{ marginBottom: "1px" }}
                                >
                                  <input
                                      className="task-input"
                                      type="text"
                                      onInput={(e) => {
                                        // Eğer girilen değer rakam değilse son karakteri siler
                                        if (e.target.value && isNaN(e.target.value.slice(-1))) {
                                          e.target.value = e.target.value.slice(0, -1);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        if (!e.target.value.trim()) { // Eğer değer boşsa
                                          e.target.style.borderColor = "red"; // Kenarlık rengini kırmızı yap
                                        } else {
                                          e.target.style.borderColor = ""; // Değer girildiyse normal renge dön
                                        }
                                      }}
                                  />
                                </Form.Item>
                              </Col>

                            </Row>
                            <Row gutter={16}></Row>
                          </div>
                        </div>
                      </div>
                    </Form>
                )}
              </Modal>
            </div>
        )}
      </div>
  );
};
export default ModalComponent;


// WEBPACK FOOTER //
// ./src/component/Modal/UserTableModal.js